import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageview, track } from './track';
import { classifyClick } from './classifyClick';

const AnalyticsListener = () => {
  const { pathname } = useLocation();

  // Rendered after <Routes>, and deferred a tick, so the page's useSeo has
  // already set document.title by the time the pageview is recorded.
  useEffect(() => {
    const t = setTimeout(pageview, 0);
    return () => clearTimeout(t);
  }, [pathname]);

  useEffect(() => {
    const onClick = (e) => {
      const hit = classifyClick(e.target, window.location);
      if (hit) track(hit[0], hit[1]);
    };
    // capture phase: still counted if a handler stops propagation or navigates
    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, []);

  return null;
};

export default AnalyticsListener;
